/** @format */

import TRANSLATIONS_ENG from './eng.json';
import _ from 'lodash';

export function I18nConfig(
    $translateProvider,
    $currencyProvider,
    Currencies,
    Languages,
    GB_ERRORS_TRANSLATIONS_ENG,
    $gbAuctionCurrencyProvider
) {
    'ngInject';

    $translateProvider
        .registerAvailableLanguageKeys(_.values(Languages))
        .preferredLanguage(Languages.eng)
        .useSanitizeValueStrategy('escapeParameters')
        .translations(Languages.eng, TRANSLATIONS_ENG)
        .translations(Languages.eng, GB_ERRORS_TRANSLATIONS_ENG);

    $currencyProvider.add(Currencies);

    $gbAuctionCurrencyProvider.setCurrencySymbolGetter(($gbAuction, $stateParams, $window, $currency) => {
        'ngInject';

        let getAuction = () => {
            return $gbAuction.cache.single($stateParams.auctionUrl);
        };

        let getCurrencySymbol = () => {
            let auction = getAuction() || $window.AUCTION;

            return auction && $currency.get(auction.currency).symbol;
        };

        return getCurrencySymbol();
    });
}
